<div class="row">
    <div class="col-3">
        <app-control 
            label='Vessel Agency' 
            [(ngModel)]="vesselAgency" 
            type="codelist"
            codelist="Organization" 
            [useCache]="false"
            [required]="isRequired('vesselAgency')"
            [isDisabled]="isDisabled('vesselAgency')"/>                         
    </div>

    <div class="col-3">
        <app-control 
        label="Captain" 
        type="string" 
        [(ngModel)]="captain" 
        [required]="isRequired('captain')"
        [isDisabled]="isDisabled('captain')"/>                                
    </div>

    <div class="col-3">
        <app-control 
            label='Confirmed Berth' 
            [(ngModel)]="berth" 
            type="codelist"
            codelist="Berth" 
            [useCache]="false"
            [required]="isRequired('confirmedBerh')"
            [isDisabled]="isDisabled('confirmedBerh')"/>                         
    </div>
</div>    